<template>
  <div class="groups__data-flow-box">
    <div class="groups__box_header d-flex align-items-center justify-content-between">
      <h6 class="mb-0">
        <RouterLink
          :to="{
            name: 'group',
            params: {
              customerId: $route.params.customerId,
              projectId: $route.params.projectId,
              id: dataFlow.deviceGroupId,
              tab: 1
            }
          }"
          class="link-gray"
        >
          <span>
            {{ $filters.strLimit(dataFlow.deviceGroupName, 50) }}
          </span>
        </RouterLink>
      </h6>
      <EditDeleteKebab
        :actions="['update', 'change']"
        @change="$emit('change')"
        @update="
          $router.push({
            name: 'group',
            params: {
              customerId: $route.params.customerId,
              projectId: $route.params.projectId,
              id: dataFlow.deviceGroupId,
              tab: 1
            }
          })
        "
      />
    </div>
    <div class="groups__box_body">
      <div class="mb-4">
        {{ $t("kTomutoDatovemuTokuJePripojenoCelkem") }}
        <RouterLink
          :to="{
            name: 'group',
            params: {
              customerId: $route.params.customerId,
              projectId: $route.params.projectId,
              id: dataFlow.deviceGroupId,
              tab: 2
            }
          }"
          class="link-gray"
        >
          <span>{{ dataFlow.devices }}&nbsp;{{ $filters.firstLower($t("zarizeni")) }}</span>
        </RouterLink>
      </div>
      <div class="d-flex">
        <div class="groups__data-flow-box__device-type">
          <div class="mb-3">
            {{ $filters.firstUpper($t("TRANSFORMATION_FUNCTION")) }}
          </div>
          <div class="groups__data-flow-box__device-type__item">
            <div v-if="transformationFunction" class="groups__box_body d-flex flex-column justify-content-between">
              <span class="font-weight-bold">{{ transformationFunction.label }}</span>
              <span>{{ transformationFunction.description }}</span>
            </div>
            <div v-else-if="!dataFlow.transformationId" class="groups__box_body">
              {{ $t("NOT_ASSIGNED") }}
            </div>
            <div v-else class="groups__box_body" />
          </div>
        </div>
        <div :class="{ 'show-before': computedEndpointList.length }" class="groups__data-flow-box__outputs">
          <div class="mb-3">
            {{ $filters.firstUpper($t("vystup")) }}
          </div>
          <div class="data-flow-diagram device-data-flow-diagram">
            <div class="data-flow-diagram__green-line device-data-flow-diagram__green-line--1-2" />
            <DataFlowDiagramEndpoints
              :data-flow="{ ...dataFlow, endpoints: computedEndpointList }"
              :show-edit-actions="false"
              :show-header="false"
              class="w-100"
              is-active
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import EditDeleteKebab from "@/components/devices/partials/EditDeleteKebab.vue"
import DataFlowDiagramEndpoints from "@/components/groups/diagram/DataFlowDiagramEndpoints.vue"
import PaginatedFetcher from "@/helpers/paginatedFetcher"
import { client } from "@/main"

export default {
  name: "DataFlow",
  components: { DataFlowDiagramEndpoints, EditDeleteKebab },
  emits: ["update", "change"],
  props: {
    dataFlow: {
      type: Object,
      required: true
    },
    deviceGroupEndpointList: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    kebabOpened: false,
    endpointList: [],
    transformationFunction: null
  }),
  created() {
    if (!this.deviceGroupEndpointList.length) {
      this.getEndpointList()
    }

    if (this.dataFlow.transformationId) {
      this.getTransformationFunction()
    }
  },
  computed: {
    computedEndpointList() {
      if (this.deviceGroupEndpointList.length) {
        return this.deviceGroupEndpointList
      } else {
        return this.endpointList
      }
    }
  },
  methods: {
    async getEndpointList() {
      const response = await axios.get(
        `${process.env.VUE_APP_API}/device-groups/${this.dataFlow.deviceGroupId}/endpoints`
      )
      this.endpointList = response.data.data
    },
    async getTransformationFunction() {
      const { data } = await client.path("/transformations/{transformationId}").method("get").create()({
        transformationId: this.dataFlow.transformationId
      })
      this.transformationFunction = data.data
    }
  }
}
</script>
